import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { IconButton } from '@mui/material';
import type { CustomerPortalInvoice } from '@vy/types';

type CustomerPortalInvoicesTableViewButtonProps = {
  invoice: CustomerPortalInvoice;
  onViewInvoice: (invoice: CustomerPortalInvoice) => void;
};

export const CustomerPortalInvoicesTableViewButton: React.FC<CustomerPortalInvoicesTableViewButtonProps> = ({
  invoice,
  onViewInvoice,
}) => {
  const handleViewClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onViewInvoice(invoice);
  };

  return (
    <IconButton
      onClick={handleViewClick}
      aria-label="View invoice"
      sx={{
        width: 32,
        height: 32,
        borderRadius: '6px',
        border: '1px solid #E7E8E9',
        color: '#323232',
        backgroundColor: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#F5F6FA',
        },
      }}
    >
      <VisibilityOutlinedIcon sx={{ fontSize: 18 }} />
    </IconButton>
  );
};
